import axios from 'axios';

import { Role, ListResponse, PartialUpdateEntity, ApiConfig } from '../types';
import { toSerializedError } from '../errors/utils';

export type ListRolesParams = {
  tenant_id: string;
};
export type ListRolesResponse = ListResponse<Omit<Role, 'scopes'>>;

export async function listRoles(
  { api_url, headers }: ApiConfig,
  params: ListRolesParams
) {
  try {
    let res = await axios.get<ListRolesResponse>(api_url+'/api/users/me/tenants/'+params.tenant_id+'/roles', {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type GetRoleParams = {
  tenant_id: string;
  name: string;
};
export type GetRoleResponse = Role;

export async function getRole(
  { api_url, headers }: ApiConfig,
  { tenant_id, name }: GetRoleParams
) {
  try {
    let res = await axios.get<Role>(api_url+'/api/users/me/tenants/'+tenant_id+'/roles/'+name, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type CreateRoleParams = {
  tenant_id: string;
  body: Pick<Role, 'name'|'type'|'title'|'description'|'scopes'|'state'>;
};
export type CreateRoleResponse = {
  role_id: string;
  request_id: string;
}

export async function createRole(
  { api_url, headers }: ApiConfig,
  { tenant_id, body }: CreateRoleParams
) {
  try {
    let res = await axios.post<CreateRoleResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/roles', body, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type UpdateRoleParams = {
  tenant_id: string;
  name: string;
  body: PartialUpdateEntity<Pick<Role, 'title'|'description'|'scopes'|'state'>>;
};
export type UpdateRoleResponse = {
  request_id: string;
}

export async function updateRole(
  { api_url, headers }: ApiConfig,
  { tenant_id, name, body }: UpdateRoleParams
) {
  try {
    let res = await axios.patch<UpdateRoleResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/roles/'+name, body, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type DeleteRoleParams = {
  tenant_id: string;
  name: string;
}
export type DeleteRoleResponse = {
  request_id: string;
}

export async function deleteRole(
  { api_url, headers }: ApiConfig,
  { tenant_id, name }: DeleteRoleParams
) {
  try {
    let res = await axios.delete<DeleteRoleResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/roles/'+name, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}
